<div class="modal fade" id="defaultModal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true" appModalFocusFix>
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="defaultModalLabel">Data Entry</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <admin-section-standard [title]="title">
          <ng-content></ng-content>
        </admin-section-standard>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-focus data-bs-dismiss="modal">{{'common.buttons.close' | translate}}</button>
      </div>
    </div>
  </div>
</div>
